exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.icon{color:#000}a.icon:hover{color:red}.arrow{margin-bottom:1.5rem;position:relative}.arrow div{height:5px;border-bottom:2px dashed #ccc}.arrow span{border:.08em dashed transparent;display:-moz-inline-box;display:inline-block;font-size:80px;height:0;line-height:0;position:absolute;top:-2px;right:-10px;vertical-align:middle;width:0;background-color:#fff;border-left-width:.15em;border-left-style:solid;border-left-color:#ccc}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0fdbfa3c","scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/StoryGraph.vue
// module id = 75
// module chunks = 0